import { Pipe, PipeTransform } from '@angular/core';
import { ISbRichtext, renderRichText } from '@storyblok/js';
import { BlockStyle, getPageWidth } from './components/block-wrapper/block-wrapper.component';
import { fixHtml } from './custom-render-text';
import { getImageHeight, getImageWidth, getPictureSourceSizes } from './custom-rich-text';
import { getStoryblokResizedUrl } from './get-resize-url';

@Pipe({
  name: 'storyblokRichText',
  standalone: true,
})
export class StoryblokRichTextPipe implements PipeTransform {
  private storyblokUrl = '//cdn.picflow.cc';
  transform(value: ISbRichtext | string, style?: BlockStyle): string {
    if (!value) return '';
    if (typeof value === 'string') return value;

    value.content.forEach(item => {
      if (item.type !== 'paragraph') return;
      item.content?.forEach((subItem, i) => {
        if (subItem.type === 'image') {
          const url = subItem.attrs.src;

          const maxWidth = getPageWidth(style.pageWidth, style.customPageWidth);
          const srcset = getPictureSourceSizes(subItem.attrs.src, maxWidth).map(
            size => `${getStoryblokResizedUrl(url, size, 90, this.storyblokUrl)} ${size}w`
          );

          subItem.attrs = {
            src: url,
            srcset: srcset.join(', '),
            alt: subItem.attrs.alt,
            title: subItem.attrs.title,
            loading: 'lazy',
            width: getImageWidth(url),
            height: getImageHeight(url),
            sizes: `(max-width: ${maxWidth}px) 100vw, ${maxWidth}px`,
          };

          // Add caption below image
          if (!subItem.attrs.title) return;

          const nextSubItem = item.content[i + 1];
          if (nextSubItem?.type === 'imageCaption') return;

          item.content.splice(i + 1, 0, {
            type: 'imageCaption',
            content: [
              {
                type: 'text',
                text: subItem.attrs.title,
              },
            ],
          });
        }
      });
    });

    return fixHtml(renderRichText(value));
  }
}
